'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ItemSelectorRaw = require('./ItemSelectorRaw.js');
var helper = require('./helper.js');
var index = require('../../components/Language/index.js');
require('../../components/Spinner/Spinner.module.css.js');
require('@babel/runtime/helpers/extends');
require('../../components/LocationCard/LocationCard.js');
require('../../components/PudoCard/PudoCard.js');
require('../../components/ItemCard/ItemCard.js');
require('../../components/SelectItem/SelectItem.js');
require('../../components/SelectList/SelectList.js');
var ErrorBanner = require('../../components/ErrorBanner/ErrorBanner.js');
require('../../components/Footer/Footer.js');
require('../../components/StickyFooter/StickyFooter.js');
require('../../components/SwatchesList/SwatchesList.js');
require('@narvar/nth-bit-text-link');
require('../../components/Backdrop/Backdrop.module.css.js');
require('../../components/LineItemsGroup/index.js');
require('../../components/Skeleton/Skeleton.module.css.js');
var SuccessBanner = require('../../components/SuccessBanner/SuccessBanner.js');
var index$1 = require('../../components/ScrollToTop/index.js');
var useCurrencyConfig = require('../../hooks/useCurrencyConfig.js');
var ItemSelector_module = require('./ItemSelector.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Banner = _ref => {
  let {
    type,
    children
  } = _ref;
  if (type === 'success') return /*#__PURE__*/React__default["default"].createElement(index$1["default"], null, /*#__PURE__*/React__default["default"].createElement(SuccessBanner["default"], null, children));
  if (type === 'error') return /*#__PURE__*/React__default["default"].createElement(index$1["default"], null, /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, children));
  return null;
};
const ItemSelector = _ref2 => {
  let {
    title,
    customer,
    allItems,
    lineItemGroupings,
    itemGroupingModeEnabled,
    selectedItems,
    splitSelectedItems,
    submittedReturns,
    onClick,
    onSubmit,
    onBack,
    onCancel,
    cancelReturnStatus,
    progressiveStep,
    activeStep,
    features,
    showOfflineReturns = 'hidden',
    disclaimer
  } = _ref2;
  const {
    locale,
    includeCurrency
  } = useCurrencyConfig["default"]();
  const [eligibleItems, ineligibleItems] = helper.filterItems(allItems, submittedReturns, showOfflineReturns);
  const splitEligibleItems = splitSelectedItems ? helper.splitItemsForMixReturns(eligibleItems, selectedItems) : eligibleItems;
  const handleClick = e => {
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: ItemSelector_module["default"].wrapper
  }, /*#__PURE__*/React__default["default"].createElement(ItemSelectorRaw.ItemSelectorRaw, {
    title,
    customer,
    lineItemGroupings,
    itemGroupingModeEnabled,
    eligibleItems: splitEligibleItems,
    onClick: handleClick,
    onSubmit,
    onBack,
    onCancel,
    submittedReturns,
    ineligibleItems,
    selectedItems,
    cancelReturnStatus,
    progressiveStep,
    activeStep,
    features,
    locale,
    includeCurrency,
    banner: /*#__PURE__*/React__default["default"].createElement("div", {
      style: {
        margin: '2rem auto'
      }
    }, /*#__PURE__*/React__default["default"].createElement(Banner, {
      type: cancelReturnStatus === null || cancelReturnStatus === void 0 ? void 0 : cancelReturnStatus.status
    }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
      langKey: `returnsItemListBanner${(cancelReturnStatus === null || cancelReturnStatus === void 0 ? void 0 : cancelReturnStatus.status) ?? ''}`,
      defaultString: cancelReturnStatus === null || cancelReturnStatus === void 0 ? void 0 : cancelReturnStatus.message
    }))),
    disclaimer
  }));
};

exports.ItemSelectorRaw = ItemSelectorRaw.ItemSelectorRaw;
exports.ItemSelector = ItemSelector;
